import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import {FieldOption, TransactionFeeFieldData} from "constants/transactionFeeV2.constants";
export const transactionFeeV2Service = createApi({
  reducerPath: "transactionFeeV2Service",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTransactionFeesV2: builder.query<any, { merchant_id?: number; partner_id?: number }>({
      query: (params) => ({
        url: `/transaction-fee/v2`,
        method: "GET",
        params,
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    getTransactionFeeByIdV2: builder.query<any, { id: number }>({
      query: (params) => ({
        url: `/transaction-fee/v2/${params.id}`,
        method: "GET",
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    createTransactionFeeV2: builder.mutation<any, any>({
      query: (params) => ({
        url: `/transaction-fee/v2`,
        body: params,
        method: "POST",
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    updateTransactionFeeV2: builder.mutation<any, { id: number; [key: string]: any }>({
      query: ({ id, ...body }) => ({
        url: `/transaction-fee/v2/${id}`,
        body,
        method: "PUT",
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    deleteTransactionFeeV2: builder.mutation<any, { id: number }>({
      query: ({ id }) => ({
        url: `/transaction-fee/v2/${id}`,
        method: "DELETE",
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    switchFeeModuleV2: builder.mutation<any, { merchantId: number; [key: string]: any }>({
      query: ({ merchantId, ...body }) => ({
        url: `/transaction-fee/v2/merchant/${merchantId}/fee-module`,
        body,
        method: "PATCH",
        headers: { PageName: "Transaction Fee" },
      }),
    }),
    getTransactionFeeFieldData: builder.query<TransactionFeeFieldData, void>({
      query: () => ({
        url: `/transaction-fee/v2/field-data`,
        method: "GET",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
      transformResponse: (raw: any): TransactionFeeFieldData => {
        const data = raw?.data ?? {};
        return {
          network:            data.dimensions.networks            ?? [],
          geography:          data.dimensions.geographies         ?? [],
          holder_type:        data.dimensions.holder_types        ?? [],
          instrument_type:    data.dimensions.instrument_types    ?? [],
          tier:               data.dimensions.tiers               ?? [],
          payment_channel:    data.payment_channels    ?? [],
          channel_dimensions: data.channel_dimensions  ?? {},
        };
      },
    }),
  }),
});

export const {
  useLazyGetTransactionFeesV2Query,
  useLazyGetTransactionFeeByIdV2Query,
  useCreateTransactionFeeV2Mutation,
  useUpdateTransactionFeeV2Mutation,
  useDeleteTransactionFeeV2Mutation,
  useSwitchFeeModuleV2Mutation,
  useGetTransactionFeeFieldDataQuery
} = transactionFeeV2Service;
